<template>
    <div>
    
        <v-sheet width="100%">
            <h4 class="title2">Brake Revisions</h4>
            <v-row v-if="noData(job)">
                <v-col class="line">
                    <span class="bold" v-if="false"><v-chip small label color="#00475a" text-color="white">&nbsp;</v-chip></span><br/>
                    <span><b>Frequency</b></span><br />
                    <span><b>Remaining</b></span><br />
                    <span><b>Next due date</b></span>
                </v-col>   
                <v-col md="3" class="pt-0">
                    <span class="bold" > <v-chip small label color="#00475a" text-color="white">{{ job?.brDays?.type }} (KM)</v-chip> </span><br/>
                    <span >{{ job?.brkm?.frequency }} {{ job?.brkm?.unit }}</span><br />
                    <span>{{ job?.brkm?.value }}</span><br />
                    <span>{{ formatdate(job?.brkm?.nextDate) }}</span>
                </v-col> 
                <v-col md="3" class="pt-0">
                    <span class="bold" > <v-chip small label color="#00475a" text-color="white">{{ job?.brDays?.type }} (DAYS) </v-chip> </span><br/>
                    <span >{{ job?.brDays?.frequency }} {{ job?.brDays?.unit }}</span><br />
                    <span>{{ job?.brDays?.value }}</span><br />
                    <span>{{ formatdate(job?.brDays?.nextDate) }}</span>
                </v-col> 
                <v-col md="3" class="pt-0">
                    <span class="bold" > <v-chip small label color="#00475a" text-color="white">BR3</v-chip> </span><br/>
                    <span >{{ job?.br3?.frequency }} {{ job?.br3?.unit }}</span><br />
                    <span>{{ job?.br3?.value }}</span><br />
                    <span>{{ formatdate(job?.br3?.nextDate) }}</span>
                </v-col> 
            </v-row>
    
            <v-row v-else class="noData">
                <v-col class="line">
                    <span class="bold">No data feedback</span><br />
                </v-col>
            </v-row>
        </v-sheet>
    
    </div>
</template>

<script>
import { formatMagicDate } from "@/shared/DateHelper";

export default {
    props: ["job"],
    data() {
        return {
        }
    },

    methods: {
        noData(job) {
            return job ?.brKm || job ?.brDays || job ?.br3;
        },

        formatdate(date) {

            if (date == null) {
                return "N/A"
            }
            return formatMagicDate(date);
        }
    },
};
</script>

<style  scoped>
.line {
    padding-bottom: 10px;
    padding-top: 0px;
    white-space: nowrap;
    overflow: hidden;
    font-size: 12px;
}

.bold {
    font-weight: bold;
    color: #00475a;
}

.noData {
  color: red !important;
}

.title2 {
  background-color: #adf3df;
  margin-bottom: 20px;
  font-weight: bold;
  font-size: 12px;
}
</style>